import { GetRemitProposalParams } from "us.collection.economy/interfaces";

export function GetRemitProposal(this: any): GetRemitProposalParams {
  return {
    remitAccount: this.remitAccount,
    ignoreExceedPayments: this.ignoreExceedPayments,
    creditors: this.creditors,
  };
}
